import { PlaceholderSection } from '../components/PlaceholderSection'

export function NetworkPage() {
  return <PlaceholderSection title="Network" />
}
